import { render, staticRenderFns } from "./TabComponentThree.vue?vue&type=template&id=69c8828a&scoped=true"
import script from "./TabComponentThree.vue?vue&type=script&lang=js"
export * from "./TabComponentThree.vue?vue&type=script&lang=js"
import style0 from "./TabComponentThree.vue?vue&type=style&index=0&id=69c8828a&prod&lang=scss&scoped=true"
import style1 from "./TabComponentThree.vue?vue&type=style&index=1&id=69c8828a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c8828a",
  null
  
)

export default component.exports